<template>
    <BreadCrumb PageTitle="Modifier un emprunt" />
    <EditEmprunt/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditEmprunt from "@/components/Emprunt/EditEmprunt.vue";
    
    export default defineComponent({
      name: "EditEmpruntPage",
      components: {
        BreadCrumb,
        EditEmprunt,
      },
    });
  </script>